// @flow
import React from 'react';
import Container from '../container';
import { Wrapper, Logo, Left, Right, NavLink } from './nav-bar.styles';
import Button from '../button';

type Props = {
  onCreateProposal: () => void,
  onLogoClick: () => void,
};

export default (props: Props) => (
  <Wrapper>
    <Container>
      <Left>
        <Logo onClick={props.onLogoClick}>munity</Logo>
      </Left>
      <Right>
        <NavLink
          href="https://medium.com/planes-agency/what-is-munity-818f37815e39"
          target="_blank"
        >
          About Munity
        </NavLink>
        <Button onClick={props.onCreateProposal}>New Propsal</Button>
      </Right>
    </Container>
  </Wrapper>
);



// WEBPACK FOOTER //
// ./src/components/nav-bar/index.js